<template>
  <div>
    <b-card no-body class="card-transparent-background">
      <b-card-header class="p-0">
        <b-card-title class="card-title-form-steps-garden-help">
<!--          Contractor Registration-->
          Sign Up Now
        </b-card-title>
        <b-card-sub-title class="card-subtitle-form-steps-garden-help">
          Please provide us with your details to start working now
        </b-card-sub-title>
      </b-card-header>
      <b-card-body class="p-0">
        <PersonalInfo
          :type="type"
          :first_name.sync="_first_name"
          :invalid_first_name="invalid_first_name"
          :last_name.sync="_last_name"
          :invalid_last_name="invalid_last_name"
          :email.sync="_email"
          :invalid_email="invalid_email"
          :invalid_correct_email="invalid_correct_email"
          :phone_number.sync="_phone_number"
          :invalid_phone_number="invalid_phone_number"
          :password.sync="_password"
          :invalid_password="invalid_password"
          :invalid_correct_password="invalid_correct_password"
          :confirm_password.sync="_confirm_password"
          :invalid_confirm_password="invalid_confirm_password"
          :invalid_correct_confirm_password="invalid_correct_confirm_password"
          :address.sync="_address" :longitude.sync="_longitude" :latitude.sync="_latitude"
          :invalid_address="invalid_address" :invalid_address_longitude="invalid_address_longitude"
          :invalid_address_latitude="invalid_address_latitude"
          :country.sync="_country" :county.sync="_county" :city.sync="_city"
          :country_code="_country_code"
        />

<!--        <b-card no-body>-->
<!--          <b-card-body class="px-2 py-4">-->
<!--            <div class="container">-->
<!--              <b-row>-->
<!--                <b-col>-->
<!--                  <b-form-group-->
<!--                    class="-->
<!--                      form-group-radio-group form-group-radio-garden-help-->
<!--                    "-->
<!--                    label="Do you want to register a company?"-->
<!--                    v-slot="{ ariaDescribedby }"-->
<!--                    label-class="form-label-garden-help text-left mb-2"-->
<!--                    :is_company="is_company"-->
<!--                  >-->
<!--                    <b-form-radio-group-->
<!--                      id="is_company"-->
<!--                      v-model="_is_company"-->
<!--                      :aria-describedby="ariaDescribedby"-->
<!--                      name="is_company"-->
<!--                      stacked-->
<!--                    >-->
<!--                      <b-form-radio-->
<!--                        class="-->
<!--                          form-control form-control-garden-help-->
<!--                          radio-input-container-->
<!--                          mb-1-->
<!--                        "-->
<!--                        v-model="is_company"-->
<!--                        :aria-describedby="ariaDescribedby"-->
<!--                        name="is_company"-->
<!--                        value="1"-->
<!--                        >Yes</b-form-radio-->
<!--                      >-->
<!--                      <b-form-radio-->
<!--                        class="-->
<!--                          form-control form-control-garden-help-->
<!--                          radio-input-container-->
<!--                          mb-1-->
<!--                        "-->
<!--                        v-model="_is_company"-->
<!--                        :aria-describedby="ariaDescribedby"-->
<!--                        name="is_company"-->
<!--                        value="0"-->
<!--                        >No, I’m a sole trader</b-form-radio-->
<!--                      >-->
<!--                    </b-form-radio-group>-->
<!--                  </b-form-group>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--            </div>-->
<!--          </b-card-body>-->
<!--        </b-card>-->

        <WorkInfo v-if="type != 'register'"
          :type="type"
          :is_company="_is_company"
          :experience_level.sync="_experience_level"
          :invalid_experience_level="invalid_experience_level"
          :service_options="service_options"
          :service.sync="_service"
          :invalid_service="invalid_service"
          :rate.sync="_rate"
          :invalid_rate="invalid_rate"
          :rate_amount.sync="_rate_amount"
          :invalid_rate_amount="invalid_rate_amount"
          :vat_number.sync="_vat_number"
          :currency="currency"
        />

        <SocialMediaInfo v-if="type != 'register'"
          :type="type"
          :linkedin.sync="_linkedin"
          :facebook.sync="_facebook"
          :website.sync="_website"
        />

<!--        <b-card no-body>-->
<!--          <b-card-body class="px-2 py-4">-->
<!--            <div class="container">-->
<!--              <b-row>-->
<!--                <b-col>-->
<!--                  <p class="form-label-garden-help my-2 float-left w-auto">-->
<!--                    Platform subscription type-->
<!--                  </p>-->

<!--                  <b-button-->
<!--                    variant="garden-help-primary-light"-->
<!--                    class="btn-bumblebee btn-garden-help float-right"-->
<!--                    v-b-modal.select-subscription-modal-->
<!--                  >-->
<!--                    Select-->
<!--                  </b-button>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--            </div>-->
<!--          </b-card-body>-->
<!--        </b-card>-->
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import PersonalInfo from "./PersonalInfo.vue";
import SocialMediaInfo from "./SocialMediaInfo.vue";
import WorkInfo from "./WorkInfo.vue";
import SelectSubscription from "@/components/subscriptions/SelectSubscription.vue";

import countries_list from '@/assets/country-list-data.json'

export default {
  name: "ContractorDetails",
  components: { PersonalInfo, SocialMediaInfo, WorkInfo, SelectSubscription },
  props: [
    "type",
    "first_name",
    "invalid_first_name",
    "last_name",
    "invalid_last_name",
    "email",
    "invalid_email",
    "invalid_correct_email",
    "phone_number",
    "invalid_phone_number",
    "password",
    "invalid_password",
    "invalid_correct_password",
    "confirm_password",
    "invalid_confirm_password",
    "invalid_correct_confirm_password",
    "linkedin",
    "facebook",
    "website",
    "experience_level",
    "invalid_experience_level",
    "service_options",
    "service",
    "invalid_service",
    "rate",
    "invalid_rate",
    "rate_amount",
    "invalid_rate_amount",
    "subscription",
    "is_company",
    "vat_number",

    "address",
    "longitude",
    "latitude",
    "invalid_address",
    "invalid_address_longitude",
    "invalid_address_latitude",
    "country",
    "county",
    "city",
    "currency",
    "country_code",
  ],

  data() {
    return {};
  },
  mounted() {},

  watch:{
    _country(newval){
      console.log("ccccccccccc",newval)
      console.log(countries_list)
      const country_data = countries_list.find(({ country }) => country === newval);
      console.log(country_data);
      this._currency = country_data.currency_code
      this._country_code = country_data.country_code
    }
  },

  computed: {
    _first_name: {
      get() {
        return this.first_name;
      },
      set(value) {
        this.$emit("update:first_name", value);
      },
    },
    _last_name: {
      get() {
        return this.last_name;
      },
      set(value) {
        this.$emit("update:last_name", value);
      },
    },
    _email: {
      get() {
        return this.email;
      },
      set(value) {
        this.$emit("update:email", value);
      },
    },
    _phone_number: {
      get() {
        return this.phone_number;
      },
      set(value) {
        this.$emit("update:phone_number", value);
      },
    },
    _password: {
      get() {
        return this.password;
      },
      set(value) {
        this.$emit("update:password", value);
      },
    },
    _confirm_password: {
      get() {
        return this.confirm_password;
      },
      set(value) {
        this.$emit("update:confirm_password", value);
      },
    },
    _linkedin: {
      get() {
        return this.linkedin;
      },
      set(value) {
        this.$emit("update:linkedin", value);
      },
    },
    _facebook: {
      get() {
        return this.facebook;
      },
      set(value) {
        this.$emit("update:facebook", value);
      },
    },

    _website: {
      get() {
        return this.website;
      },
      set(value) {
        this.$emit("update:website", value);
      },
    },
    _experience_level: {
      get() {
        return this.experience_level;
      },
      set(value) {
        this.$emit("update:experience_level", value);
      },
    },
    _service: {
      get() {
        return this.service;
      },
      set(value) {
        this.$emit("update:service", value);
      },
    },
    _rate: {
      get() {
        return this.rate;
      },
      set(value) {
        this.$emit("update:rate", value);
      },
    },
    _rate_amount: {
      get() {
        return this.rate_amount;
      },
      set(value) {
        this.$emit("update:rate_amount", value);
      },
    },
    _subscription: {
      get() {
        return this.subscription;
      },
      set(value) {
        this.$emit("update:subscription", value);
      },
    },
    _is_company: {
      get() {
        return this.is_company;
      },
      set(value) {
        this.$emit("update:is_company", value);
      },
    },
    _vat_number: {
      get() {
        return this.vat_number;
      },
      set(value) {
        this.$emit("update:vat_number", value);
      },
    },
    
    _address: {
      get() {
        return this.address;
      },
      set(value) {
        this.$emit("update:address", value);
      },
    },
    _longitude: {
      get() {
        return this.longitude;
      },
      set(value) {
        this.$emit("update:longitude", value);
      },
    },
    _latitude: {
      get() {
        return this.latitude;
      },
      set(value) {
        this.$emit("update:latitude", value);
      },
    },
    
    _country: {
      get() {
        return this.country;
      },
      set(value) {
        this.$emit("update:country", value);
      },
    },
    _county: {
      get() {
        return this.county;
      },
      set(value) {
        this.$emit("update:county", value);
      },
    },
    _city: {
      get() {
        return this.city;
      },
      set(value) {
        this.$emit("update:city", value);
      },
    },
    _currency:{
      get() {
        return this.currency;
      },
      set(value) {
        this.$emit("update:currency", value);
      },
    },
    _country_code:{
      get() {
        return this.country_code;
      },
      set(value) {
        this.$emit("update:country_code", value);
      },
    }
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/ContractorDetails.vue